/*
   Browser helper for calling the site's own API routes with JSON.
   Always resolves (never throws) so forms can show a calm message.
*/

export interface ApiResult<T = Record<string, unknown>> {
    ok: boolean
    status: number
    data: T & { message?: string, errors?: Record<string, string> }
}

export const sendJson = async <T = Record<string, unknown>>(url: string, method: 'POST' | 'DELETE', body?: unknown): Promise<ApiResult<T>> => {
    try {
        const response = await fetch(url, {
            method,
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: body === undefined ? undefined : JSON.stringify(body)
        })

        const data = await response.json().catch(() => ({}))

        return { ok: response.ok, status: response.status, data }
    }
    catch {
        return {
            ok: false,
            status: 0,
            data: { message: 'We could not reach the server. Please check your connection and try again.' } as ApiResult<T>['data']
        }
    }
}
